<template>
  <form method="post" ref="checkoutForm">
    <GenericModal
      v-if="displayLocalErrors"
      :unique-id="`CheckoutErrors`"
      :ref="'CheckoutErrorsModal'"
      :has-header="false"
      :has-footer="false"
      :close-btn-color="'#ef1b1b'"
      :width="'780px'"
      :max-height="'520px'"
    >
      <CheckoutErrors
        :errors="localErrors"
      >
      </CheckoutErrors>
    </GenericModal>
    <LeasingCheckoutProductCard v-if="albisOptions.product" :product="albisOptions.product"/>
    <div class="container previewOrderContainer mt-4">
      <div class="row">
        <div class="col-12"><h1>{{ t('preview.order.order.details') }}</h1></div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-6">
          <div>
            <div id="customerOrderDetails" class="checkout-form-block">
              <div class="row">
                <div class="col-12 checkout-form-header">
                  <span class="checkout-form-title">{{ t('preview.order.order.details') }}</span>
                </div>
                <div class="col-12 checkout-form-col">
                  <label for="legalForm"><sup>*</sup> {{ t('lease.legal.form') }}:</label>
                  <select name="legalForm" id="legalForm" class="form-control dropdown_custom_field"
                      :data-field_name="t('lease.legal.form')" v-model="albisOptionsSelectedLegalForm" required>
                    <option v-for="legalForm in albisOptions.legalForms" :value="legalForm.id" :key="legalForm.id">{{ legalForm.text }}</option>
                  </select>
                </div>
                <div class="col-12 col-md-6 checkout-form-col">
                  <label for="lesseeName"><sup>*</sup> {{ t('lessee.name') }}:</label>
                  <input type="text" id="lesseeName" name="lesseeName" class="form-control"
                         :data-field_name="t('lessee.name')"
                         :placeholder="t('lessee.name')" required
                         v-model="lesseeName">
                </div>
                <div class="col-12 col-md-6 checkout-form-col">
                  <label for="lesseeSurname"><sup>*</sup> {{ t('lessee.surname') }}:</label>
                  <input type="text" id="lesseeSurname" name="lesseeSurname" class="form-control"
                         :data-field_name="t('lessee.surname')"
                         :placeholder="t('lessee.surname')" required
                         v-model="lesseeSurname">
                </div>
                <div class="col-12 col-md-6 checkout-form-col">
                  <label for="lesseePostalCode"><sup>*</sup> {{ t('lessee.postal.code') }}:</label>
                  <input type="text" name="lesseePostalCode" id="lesseePostalCode" class="form-control"
                         :data-field_name="t('lessee.postal.code')"
                         :placeholder="t('lessee.postal.code')" required
                         v-model="lesseePostalCode">
                </div>
                <div class="col-12 col-md-6 checkout-form-col">
                  <label for="lesseePhone">{{ t('lessee.phone') }}:</label>
                  <input type="text" id="lesseePhone" name="lesseePhone" class="form-control"
                         :data-field_name="t('lessee.phone')"
                         :placeholder="t('lessee.phone')"
                         v-model="lesseePhone">
                </div>
                <div class="col-12 col-md-6 checkout-form-col">
                  <label for="lesseeFax">{{ t('lessee.fax') }}:</label>
                  <input type="text" id="lesseeFax" name="lesseeFax" class="form-control"
                         :data-field_name="t('lessee.fax')"
                         :placeholder="t('lessee.fax')"
                         v-model="lesseeFax">
                </div>
                <div class="col-12 form-group  checkout-form-col">
                  <label for="lesseeEmail">{{ t('lessee.email') }}:</label>
                  <input
                      type="email"
                      name="lesseeEmail"
                      id="lesseeEmail"
                      class="form-control"
                      :data-field_name="t('lessee.email')"
                      :placeholder="t('lessee.email')"
                      v-model="lesseeEmail">
                </div>
                <div class="col-12 col-md-6 checkout-form-col">
                  <label for="lesseeStreetAddress"><sup>*</sup> {{ t('lessee.street.address') }}:</label>
                  <input type="text" name="lesseeStreetAddress" id="lesseeStreetAddress" class="form-control"
                         :data-field_name="t('lessee.street.address')"
                         :placeholder="t('lessee.street.address')" required
                         v-model="lesseeStreetAddress">
                </div>
                <div class="col-12 col-md-6 checkout-form-col">
                  <label for="lesseeCity"><sup>*</sup> {{ t('lessee.city') }}:</label>
                  <input type="text" name="lesseeCity" id="lesseeCity" class="form-control"
                         :data-field_name="t('lessee.city')"
                         :placeholder="t('lessee.city')" required
                         v-model="lesseeCity">
                </div>
                <div class="col-12 checkout-form-col">
                  <label for="iban">{{ t('albis.iban') }}:</label>
                  <input type="text" name="iban" id="iban" class="form-control" :data-field_name="t('albis.iban')"
                         :placeholder="t('albis.iban')" v-model="iban">
                </div>
                <div class="col-12 checkout-form-col">
                    <span class="checkout-form-title">{{ t('albis.object.insurance') }}</span>
                    <div class="row">
                      <div class=" col-12  col-md-6">
                        <input name="insurance" value="yes" type="radio" id="objectInsuranceYes"
                               class="custom-control-input"
                               v-model="insurance">
                        <label class="custom-control-label" for="objectInsuranceYes">{{t('albis.object.insurance.yes')}}</label>
                      </div>
                      <div class=" col-12 col-md-6">
                        <input name="insurance" value="no" type="radio" id="objectInsuranceNo"
                               class="custom-control-input"
                               v-model="insurance">
                        <label class="custom-control-label" for="objectInsuranceNo">{{t('albis.object.insurance.no')}}</label>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 checkout-side">
          <div id="ceoSalutationBlock" class="checkout-form-block">
            <div class="invoiceType">
              <div class="row">
                <div class="col-12 checkout-form-header">
                  <span class="checkout-form-title">{{ t('ceo.salutation') }}</span>
                  <div class="col-12 pl-0">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input name="ceoSalutation" value="1" type="radio" id="ceoSalutationMale"
                             class="custom-control-input"
                             v-model="ceoSalutation">
                      <label class="custom-control-label" for="ceoSalutationMale">
                        {{ t('ceo.salutation.male') }}
                      </label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input name="ceoSalutation" value="2" type="radio" id="ceoSalutationFemale"
                             class="custom-control-input"
                             v-model="ceoSalutation">
                      <label class="custom-control-label" for="ceoSalutationFemale">
                        {{ t('ceo.salutation.female') }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 checkout-form-col">
            <label for="ceoName"><sup>*</sup> {{ t('ceo.name') }}:</label>
            <input type="text" name="ceoName" id="ceoName" class="form-control"
                   :data-field_name="t('ceo.name')"
                   :placeholder="t('ceo.name')" required
                   v-model="ceoName">
          </div>
          <div class="col-12 col-md-6 checkout-form-col">
            <label for="ceoSurname"><sup>*</sup> {{ t('ceo.surname') }}:</label>
            <input type="text" name="ceoSurname" id="ceoSurname" class="form-control"
                   :data-field_name="t('ceo.surname')"
                   :placeholder="t('ceo.surname')" required
                   v-model="ceoSurname">
          </div>
          <div class="col-12 col-md-6 checkout-form-col">
            <label for="ceoStreetAddress">{{ t('ceo.street.address') }}:</label>
            <input type="text" name="ceoStreetAddress" id="ceoStreetAddress" class="form-control"
                   :placeholder="t('ceo.street.address')"
                   v-model="ceoStreetAddress">
          </div>
          <div class="col-12 col-md-6 checkout-form-col">
            <label for="ceoPostalCode">{{ t('ceo.postal.code') }}:</label>
            <input type="text" id="ceoPostalCode" name="ceoPostalCode" class="form-control"
                   :placeholder="t('ceo.postal.code')"
                   v-model="ceoPostalCode">
          </div>
          <div class="col-12 col-md-6 checkout-form-col">
            <label for="ceoCity">{{ t('ceo.city') }}:</label>
            <input type="text" id="ceoCity" name="ceoCity" class="form-control"
                   :placeholder="t('ceo.city')"
                   v-model="ceoCity">
          </div>
          <div class="col-12 col-md-6 checkout-form-col">
            <label for="ceoDob">{{ t('ceo.dob') }}:</label>
            <input type="date" id="ceoDob" name="ceoDob" class="form-control"
                   :data-field_name="t('ceo.dob')" pattern="\d{4}-\d{2}-\d{2}"
                   :placeholder="t('ceo.dob')"
                   v-model="ceoDob">
          </div>
          <div class="col-12 col-md-6 checkout-form-col">
            <label for="ceoPhone">{{ t('ceo.phone') }}:</label>
            <input type="text" id="ceoPhone" name="ceoPhone" class="form-control"
                   :data-field_name="t('ceo.phone')"
                   :placeholder="t('ceo.phone')"
                   v-model="ceoPhone">
          </div>
          <div class="col-12 col-md-6 checkout-form-col">
            <label for="ceoFax">{{ t('ceo.fax') }}:</label>
            <input type="text" id="ceoFax" name="ceoFax" class="form-control"
                   :data-field_name="t('ceo.fax')"
                   :placeholder="t('ceo.fax')"
                   v-model="ceoFax">
          </div>
          <!-- one option 1/VA todo set to hidden/constant ?-->
          <div class="col-12 col-md-6 checkout-form-col">
            <label for="contractType"><sup>*</sup> {{ t('lease.contract.type') }}:</label>
            <select
                name="contractType"
                id="contractType"
                class="form-control dropdown_custom_field"
                :data-field_name="t('lease.contract.type')"
                v-model="albisOptionsSelectedContractType"
                required>
              <option v-for="contractType in albisOptions.contractTypes" :value="contractType.id" :key="contractType.id">
                {{ contractType.bezeichnung }}
              </option>
            </select>
          </div>
          <div class="col-12 col-md-6 checkout-form-col">
            <label for="paymentMethod"><sup>*</sup> {{ t('lease.payment.method') }}:</label>
            <select
                name="paymentMethod"
                id="paymentMethod"
                class="form-control dropdown_custom_field"
                :data-field_name="t('lease.payment.method')"
                v-model="albisOptionsSelectedPaymentMethod"
                required>
              <option v-for="paymentMethod in albisOptions.paymentMethods" :value="paymentMethod.id" :key="paymentMethod.id">
                {{ paymentMethod.bezeichnung }}
              </option>
            </select>
          </div>
          <!-- one option 23/Grßküchentechnik todo set to hidden/constant ? -->
          <div class="col-12 col-md-6 checkout-form-col">
            <label for="productGroup"><sup>*</sup> {{ t('lease.product.group') }}:</label>
            <select
                name="productGroup"
                id="productGroup"
                class="form-control dropdown_custom_field"
                :data-field_name="t('lease.product.group')"
                v-model="albisOptionsSelectedProductGroup"
                required>
              <option v-for="productGroup in albisOptions.productGroups" :value="productGroup.id" :key="productGroup.id">
                {{ productGroup.bezeichnung }}
              </option>
            </select>
          </div>
          <div v-if="albisOptions.rates && albisOptions.rates.length > 0" class="col-12 col-md-6 checkout-form-col">
            <label for="rate"><sup>*</sup> {{ t('lease.rate') }}:</label>
            <select
              name="rate"
              id="rate"
              class="form-control dropdown_custom_field"
              :data-field_name="t('lease.rate')"
              v-model="albisOptionsSelectedRate"
              required>
              <option v-for="(rate, rateIdx) in albisOptions.rates" :value="rate.laufzeit" :key="rateIdx">
                Months - {{ rate.laufzeit }} - Price - {{ rate.rate }}
              </option>
            </select>
          </div>
          <div v-if="albisOptionsSelected.contractType && albisOptionsSelected.paymentMethod && albisOptionsSelected.productGroup" class="col-12 checkout-form-col get-rates-btn-container">
            <button @click="getRateOptions" type="button" value="true" formnovalidate="formnovalidate" class="btn btn-primary">
              Get Rates
            </button>
          </div>
          <div class="col-12 customerOrderShippingDetailsCheckbox">
            <div class="checkbox">
              <input type="checkbox"
                     class="checkbox_input"
                     id="sendContractEmail"
                     name="sendContractEmail"
                     value="1"
                     v-model="sendContractEmail"
              >
              <label class="checkbox_label" for="sendContractEmail">
                {{ t('leasing.preview.order.sendContractEmail') }}
              </label>
            </div>
          </div>
        </div>

        <div id="customerFormSubmit" class="checkout-form-block">
          <div class="row">
            <div class="col-12 col-md-6 prev-terms-row">
              <div class="row">
                <p><sup>*</sup> {{ t('albis.data.protection.conformity') }}</p>
                <div class="col-12  checkbox termsAgree">
                  <input
                      id="termsacceptcheck"
                      type="checkbox"
                      class="checkbox_input"
                      required
                      name="accept_terms"
                      :data-field_name="t('customer.register.terms')"
                  >
                  <label for="termsacceptcheck" class="checkbox_label">
                    {{ t('customer.register.terms.agree') }}
                    <a target="_blank" :href="t('customer.register.terms.link.href')">
                      {{ t('customer.register.terms.link') }}
                    </a>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-xl-4 ml-auto checkout-submit-row text-right">
              <button class="submit-btn" name="preview_submit" value="true" formnovalidate @click="createApplication" type="button">
                {{ t('preview.order.continue') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import store from '../../vue/store'
import { mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
import leasingCheckoutPage from '../../vue/mixins/leasingCheckoutPage'
import GenericModal from './presentation/GenericModal.vue'
import CheckoutErrors from './CheckoutErrors.vue'
import LeasingCheckoutProductCard from './LeasingCheckoutProductCard.vue'

export default {
  name: 'leasingCheckoutPage',
  mixins: [leasingCheckoutPage],
  components: {
    GenericModal,
    CheckoutErrors,
    LeasingCheckoutProductCard
  },
  data () {
    return {
      albisOptionsSelectedContractType: null,
      albisOptionsSelectedPaymentMethod: null,
      albisOptionsSelectedProductGroup: null,
      albisOptionsSelectedLegalForm: null,
      albisOptionsSelectedRate: null,
      lesseeName: '',
      lesseeSurname: '',
      lesseePostalCode: '',
      lesseePhone: '',
      lesseeFax: '',
      lesseeEmail: '',
      lesseeStreetAddress: '',
      lesseeCity: '',
      ceoSalutation: '',
      ceoName: '',
      ceoSurname: '',
      ceoStreetAddress: '',
      ceoPostalCode: '',
      ceoCity: '',
      ceoDob: '',
      ceoPhone: '',
      ceoFax: '',
      iban: '',
      sendContractEmail: '',
      insurance: ''
    }
  },
  watch: {
    albisOptionsSelectedContractType (val) {
      const albisOptionsSelected = cloneDeep(this.albisOptionsSelected)
      albisOptionsSelected.contractType = val
      store.dispatch('setAlbisOptionsSelected', albisOptionsSelected)
    },
    albisOptionsSelectedPaymentMethod (val) {
      const albisOptionsSelected = cloneDeep(this.albisOptionsSelected)
      albisOptionsSelected.paymentMethod = val
      store.dispatch('setAlbisOptionsSelected', albisOptionsSelected)
    },
    albisOptionsSelectedProductGroup (val) {
      const albisOptionsSelected = cloneDeep(this.albisOptionsSelected)
      albisOptionsSelected.productGroup = val
      store.dispatch('setAlbisOptionsSelected', albisOptionsSelected)
    },
    albisOptionsSelectedLegalForm (val) {
      const albisOptionsSelected = cloneDeep(this.albisOptionsSelected)
      albisOptionsSelected.legalForm = val
      store.dispatch('setAlbisOptionsSelected', albisOptionsSelected)
    },
    albisOptionsSelectedRate (val) {
      const albisOptionsSelected = cloneDeep(this.albisOptionsSelected)
      albisOptionsSelected.rate = val
      store.dispatch('setAlbisOptionsSelected', albisOptionsSelected)
    }
  },
  computed: {
    albisOptions () {
      return store.getters.getAlbisOptions
    },
    albisOptionsSelected () {
      return store.getters.getAlbisOptionsSelected
    }
  },
  methods: {
    ...mapActions(['getRates', 'callCreateApplication']),
    getRateOptions () {
      this.getRates({
        netPrice: this.albisOptions.netPrice,
        productGroup: this.albisOptionsSelected.productGroup, // @todo set to constant
        downPayment: 0, // this.albisOptionsSelected.downPayment,
        contractType: this.albisOptionsSelected.contractType, // @todo set to constant
        paymentMethod: this.albisOptionsSelected.paymentMethod,
        commission: this.albisOptionsSelected.commission
      })
    },
    createApplication () {
      const formIsValid = this.validateForm()

      if (formIsValid) {
        const selectedRateData = this.albisOptions.rates.find(obj => {
          return obj.laufzeit === this.albisOptionsSelectedRate
        })
        this.callCreateApplication({
          lesseeName: this.lesseeName,
          lesseeSurname: this.lesseeSurname,
          lesseePostalCode: this.lesseePostalCode,
          lesseePhone: this.lesseePhone,
          lesseeFax: this.lesseeFax,
          lesseeEmail: this.lesseeEmail,
          lesseeStreetAddress: this.lesseeStreetAddress,
          lesseeCity: this.lesseeCity,
          ceoName: this.ceoName,
          ceoSurname: this.ceoSurname,
          ceoStreetAddress: this.ceoStreetAddress,
          ceoPostalCode: this.ceoPostalCode,
          ceoCity: this.ceoCity,
          ceoDob: this.ceoDob,
          ceoPhone: this.ceoPhone,
          ceoFax: this.ceoFax,
          iban: this.iban,
          leaseObject: this.albisOptions.productName,
          netPrice: this.albisOptions.netPrice,
          specialLeasePayments: '', // todo
          leaseTermMonths: selectedRateData.laufzeit, // todo απο την getRates
          rate: selectedRateData.rate, // todo απο την getRates
          legalForm: this.albisOptionsSelected.legalForm,
          ceoSalutation: this.ceoSalutation,
          commissionPercentage: '', // todo
          objectInsurance: this.insurance,
          productGroup: this.albisOptionsSelected.productGroup,
          contractType: this.albisOptionsSelected.contractType,
          paymentMethod: this.albisOptionsSelected.paymentMethod,
          serviceFee: '', // todo
          sendContractEmail: this.sendContractEmail,
          productId: this.albisOptions.product.product_id
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.get-rates-btn-container {
  display: grid;
  justify-items: center;
  align-items: center;
  align-content: center;
  justify-content: center;
}
sup {
  color: red;
  font-size: 14px;
}
</style>
